export default "__VITE_ASSET__BN3E_K5O__"